// app/javascript/controllers/trix_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Trix controller collegato", this.element)

    this._onFileAccept = this.onFileAccept.bind(this)
    document.addEventListener("trix-file-accept", this._onFileAccept)
  }

  disconnect() {
    document.removeEventListener("trix-file-accept", this._onFileAccept)
  }

  onFileAccept(event) {
    // opzionale: limita SOLO a questo editor
    if (event.target !== this.element) return

    event.preventDefault()
    // console.log("Caricamento file disabilitato")
  }
}